// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__9pPmL","column":"style_column__4D6pm","row":"style_row__1UI77"};